import { FlexLayout, H4 } from '@deity/falcon-ui';
import type { FC } from 'react';
import { ContentType, Host, Method, Path, Protocol } from './Properties';

interface ConfigurationProps {
  isEditable: boolean;
  endpoint: {
    protocol?: 'http' | 'https';
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
    contentType?: 'application/json';
    host?: string;
    path?: string;
  };
  service: {
    protocol?: 'http' | 'https';
    contentType?: 'application/json';
    host?: string;
  };
  onChange: (key: string[], val: any, set?: boolean) => void;
}
const Configuration: FC<ConfigurationProps> = ({ isEditable, onChange, endpoint, service }) => (
  <FlexLayout p="xxl" flexDirection="column">
    <H4 fontWeight="semiBold" fontSize="xl">
      Configuration
    </H4>
    <Protocol protocol={endpoint.protocol} parent={service.protocol} onChange={onChange} isEditable={isEditable} />
    <Method style={{ width: '50%' }} method={endpoint.method} onChange={onChange} isEditable={isEditable} />
    <ContentType
      contentType={endpoint.contentType}
      parent={service.contentType}
      onChange={onChange}
      isEditable={isEditable}
    />
    <Host host={endpoint.host} parent={service.host} onChange={onChange} isEditable={isEditable} />
    <Path path={endpoint.path} onChange={onChange} isEditable={isEditable} />
  </FlexLayout>
);

export default Configuration;
